import { Input } from '@sixfold/common-ui';
import { isNil } from '@sixfold/typed-primitives';
import classNames from 'classnames';

import styles from './styles.module.css';

const PLATFORM_ID_KEY = 'PLATFORM_ID';

export type DiscriminatorRecord = { [key: string]: { key: string; value: string }[] };

// Discriminator is typed as GraphQLJSON api-gateway side, actual type conforms to DiscriminatorRecord
export function parseDiscriminator(
  raw: { [key: string]: string | number | boolean | object } | undefined,
): DiscriminatorRecord {
  if (isNil(raw)) {
    return {};
  }
  return raw as DiscriminatorRecord;
}

export function extractPlatformIdFromDiscriminator(discriminator: DiscriminatorRecord): string {
  const firstEntry = Object.values(discriminator)[0];
  return firstEntry?.find((v) => v.key === PLATFORM_ID_KEY)?.value ?? '';
}

export function buildDiscriminatorForTopics(platformId: string, topics: string[]): DiscriminatorRecord {
  if (platformId.trim() === '') {
    return {};
  }
  return Object.fromEntries(topics.map((topic) => [topic, [{ key: PLATFORM_ID_KEY, value: platformId.trim() }]]));
}

interface WebhookDiscriminatorFieldProps {
  isEditing: boolean;
  platformId: string;
  discriminator: DiscriminatorRecord;
  onPlatformIdChange: (platformId: string) => void;
}

export function WebhookDiscriminatorField(props: WebhookDiscriminatorFieldProps) {
  const { isEditing, platformId, discriminator, onPlatformIdChange } = props;

  if (isEditing) {
    return (
      <div className={classNames(styles.editorContainer, styles.editorContainerGapSmall)}>
        <Input
          label="Platform ID"
          placeholder="Enter platform ID (applies to all selected topics)"
          className={classNames(styles.fieldInputWrapper)}
          labelPosition="hidden"
          name="platform-id"
          value={platformId}
          onChange={(e) => onPlatformIdChange(e.value)}
        />
      </div>
    );
  }

  const displayPlatformId = extractPlatformIdFromDiscriminator(discriminator);

  if (displayPlatformId === '') {
    return <span>-</span>;
  }

  return (
    <div className={styles.fieldRow}>
      <span>Platform ID: </span>
      <code className={styles.codeTag}>{displayPlatformId}</code>
    </div>
  );
}
